import { cx } from 'src/utils/cx'

export function RankingOverlay(
  props: {
    rankingOpts: {
      rankNumber: number
    }
    title?: string
  } & StyleProps,
) {
  return (
    <div
      className={cx(
        'mt-auto items-center w-full bg-black/50 px-6 gap-4',
        props.className,
      )}
      style={{
        display: 'flex',
        height: '6em',
      }}
    >
      <p
        className="flex items-center justify-center text-white font-semibold rounded bg-purple-700 tabular-nums pointer-events-none"
        style={{
          fontSize: '2em',
          width: '2.25em',
          padding: '0.325em 0',
        }}
      >
        {props.rankingOpts.rankNumber}
      </p>
      <p
        className={cx('font-semibold capitalize shrink-0 text-white')}
        style={{
          fontSize: '1.5em',
        }}
      >
        {props.title}
      </p>
    </div>
  )
}
